(() => {
  if (window.hshpCartAccessories) return;
  window.hshpCartAccessories = true;
  const root = window.Shopify?.routes?.root || '/';
  let timer, controller, version = 0, latestProduct = null, adding = false;
  const hosts = () => [...document.querySelectorAll('[data-hshp-recommendations]')];
  const strings = () => JSON.parse(document.getElementById('hshp-cart-strings')?.textContent || '{}');
  function paint(markup) {
    const result = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-hshp-rec-results]');
    if (!result) return;
    let cards = [...result.querySelectorAll('.hshp-rec-card')];
    if (latestProduct) cards.sort((a,b) => Number(b.dataset.sourceProduct === String(latestProduct)) - Number(a.dataset.sourceProduct === String(latestProduct)));
    hosts().forEach(host => {
      const list = host.querySelector('.hshp-rec-list');
      const activeButton = document.activeElement?.closest('.hshp-rec-card');
      const focusProduct = host.contains(activeButton) ? activeButton.dataset.productId : null;
      list.replaceChildren(...cards.slice(0, Number(host.dataset.limit || 4)).map(card => card.cloneNode(true)));
      host.hidden = !cards.length;
      if (focusProduct) host.querySelector('.hshp-rec-add')?.focus({preventScroll:true});
    });
    const shell = document.querySelector('.hshp-cart-shell');
    shell?.classList.toggle('hshp-has-recommendations', !!cards.length);
  }
  async function refresh() {
    clearTimeout(timer);
    controller?.abort();
    controller = new AbortController();
    const current = ++version;
    try {
      const response = await fetch(root + '?sections=hshp-cart-recommendations', {signal: controller.signal});
      if (!response.ok) throw new Error('recommendations');
      const data = await response.json();
      if (current === version && data['hshp-cart-recommendations']) paint(data['hshp-cart-recommendations']);
    } catch(error) {
      if (error.name !== 'AbortError') {
        hosts().forEach(host => host.hidden = true);
        document.querySelector('.hshp-cart-shell')?.classList.remove('hshp-has-recommendations');
      }
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 120); }
  async function add(button) {
    if (adding || button.disabled) return;
    adding = true;
    const host = button.closest('[data-hshp-recommendations]');
    const status = host.querySelector('.hshp-rec-status');
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    button.textContent = strings().adding;
    status.textContent = '';
    let committed = false;
    try {
      const mini = document.querySelector('mini-cart');
      const sections = mini?.getSectionsToRender().map(section => section.section) || [];
      const response = await fetch(window.routes?.cart_add_url || root + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:Number(button.dataset.quantity || 1)}],sections:sections.slice(0,5),sections_url:location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || strings().error);
      committed = true;
      status.textContent = strings().added;
      if (mini) {
        try { mini.renderContents(data); } catch { await mini.updateSectionContents(); }
      }
      const cartItems = document.querySelector('cart-items');
      if (cartItems) await cartItems.updateSectionContents();
      document.dispatchEvent(new CustomEvent('cart:item-add',{detail:{items:data.items || [],context:'hshp-accessories'}}));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartItemAdd,{source:'hshp-accessories',items:data.items || []});
      await refresh();
    } catch(error) {
      status.textContent = committed ? strings().refresh_error : error.message || strings().error;
      if (committed) schedule();
    } finally {
      adding = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = strings().add;
    }
  }
  function init() {
    document.addEventListener('click',event => {
      const button = event.target.closest('button.hshp-rec-add');
      if (button) { event.preventDefault(); add(button); }
    });
    document.addEventListener('cart:item-add',event => {
      if (event.detail?.context !== 'hshp-accessories') latestProduct = event.detail?.items?.[0]?.product_id || null;
      schedule();
    });
    ['cart:item-remove','cart:item-quantity-update','cart-drawer:open','mini-cart:opened'].forEach(name => document.addEventListener(name,schedule));
    const content = document.getElementById('header-mini-cart-content');
    if (content) new MutationObserver(schedule).observe(content,{childList:true,subtree:true});
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate,schedule);
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();